import dayjs from "dayjs";
import { http } from "../http-common";

const getCropStage = (config = {}) => {
  return http.get(`/cropStages`, config);
};

const getCropYear = (config) => {
  return http.get(`/cropYears`, config);
};
const getSurveyApproverData = (params, config = {}) => {
  // const p = {
  //         "cropYear": 2024,
  //         "cropStageId": "BEDBE8A9-A107-4BB7-A3F8-0692DA71D431",
  //         "isVisitCompliance": true
  // }
  return http.post(
    `/surveyApprover?pageNumber=${params?.pageNumber}&pageSize=${params?.size}&isVisitCompliance=${params?.isVisitCompliance}`,
    params,
    config
  );
};
const getHierarchyDropdown = (data, config = {}) => {
  return http.get(`/hierarchy/hierarchy-drop-down?isMuv=${data.isMuv}&cropYear=${data.cropYear}`, config);
};
const reopenSurveys = (params, config = {}) => {
  return http.post(
    `/surveyApprover/updateSurveyStatus?statusToUpdate=${params?.statusToUpdate}`,
    params,
    config
  );
};
const getIsApprover = (cropYear, config = {}) => {
  return http.get(`/hierarchy/isApprover?cropYear=${cropYear}`, config);
};

const getImageUrl = (fileUrl) => {
  return http.get(`/storage?fileUrl=${fileUrl}`);
};

const getViewSurvey = (
  headerId,
  isVisitCompliance,
  cropStageId,
  cropYear,
  headers
) => {
  return http.get(`/surveyApprover/surveyDetail`, {
    params: {
      headerId,
      isVisitCompliance,
      cropStageId,
      cropYear,
    },
    headers,
  });
};

const reopenSurvey = (cropYear ,cropStageId,headerIds, reopenComment, headers, approverName) => {
  return http.post(
    `/surveyApprover/updateSurveyStatus?statusToUpdate=Re-Opened`,
    {cropYear,
      cropStageId,
      headerIds,
      reopenComment,
      actionDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"), // ISO format with timezone
      approverName: approverName,
    },
    {
      headers,
    }
  );
};

const approveSurvey = (headerIds, headers, approverName) => {
  return http.post(
    `/surveyApprover/updateSurveyStatus?statusToUpdate=Approved`,
    {
      headerIds,
      actionDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"), // ISO format with timezone
      approverName: approverName,
    },

    {
      headers,
    }
  );
};
const fetchPickListSurvey = (data, headers) => {
  return http.post("/picklist", data, headers);
};

const getLabelTranslations = (config) => {
  return http.get("/active-reportStaticTranslations", config);
};

const SurveyManagementService = {
  getCropYear,
  getCropStage,
  getSurveyApproverData,
  getHierarchyDropdown,
  reopenSurveys,
  getIsApprover,
  getImageUrl,
  getViewSurvey,
  reopenSurvey,
  approveSurvey,
  fetchPickListSurvey,
  getLabelTranslations
};

export default SurveyManagementService;
